import React, { useEffect } from 'react';
import { RiRobot2Fill } from 'react-icons/ri';
import { Avatar } from '../avatar/Avatar.jsx';

const ChatBotConversation = ({ conversation, userData }) => {
    const _DEFAULT_INITIALS = 'AN';

    useEffect(() => {
        const messagesContainer = document.getElementById('messages');
        if (messagesContainer) {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
    }, [conversation]); // Dependency on conversation to trigger the effect when it changes

    useEffect(() => {
        // Scroll to the bottom of the messages container when conversation changes
        const messagesContainer = document.getElementById('messages');
        if (messagesContainer) {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
    }, [conversation]);
    return (
        <div className="messages items-center">
            {conversation.map((message, index) => (
                <div key={index} className={`${message.user ? 'items-right justify-end user' : 'justify-start items-left bot'} response p-2 text-base flex`}>
                    {message.user ?
                        <div className='flex gap-2'>
                            <span className="user-span pt-1 pr-2 pl-2">
                                {message.user}
                            </span>
                            <div className='user-halo text-white bg-gradient-to-b from-yellow to-orange font-medium rounded-full text-sm text-center me-2 mb-2 w-8 h-8 rounded-2xl pt-1.5'>
                                {userData.fullName ? userData.fullName.charAt(0).toUpperCase() : _DEFAULT_INITIALS}
                            </div>
                        </div>
                        :
                        <div className='flex gap-2'>
                            <div className='bot-avatar'>
                                {userData.avStatus ?
                                    (
                                        <Avatar className='h-10 w-10' {...userData.userAvatarColors} width={12} height={12} {...userData.userAvatarStyles} />
                                    )
                                    : (
                                        <RiRobot2Fill className='bot-avatarrounded-2xl w-7 h-7' alt="Bot"></
                                            RiRobot2Fill>
                                    )
                                }
                            </div>
                            <span className="chatbot-span pt-1 pr-2 pl-2 self-end overflow-y-auto">
                                {message.bot}
                            </span>
                        </div>
                    }
                </div>
            ))}
        </div>
    );
};

export default ChatBotConversation;
